import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tax-equivalent-yield',
  component: () => import('../../routes/TaxEquivYieldCalculator.svelte'),
  card: {
    id: 'tax-equivalent-yield',
    title: 'Tax-Equivalent Yield',
    description: 'Compare municipal bond yields with taxable bonds. Find out what taxable yield you need to match a tax-exempt municipal bond return.',
    icon: 'account_balance_wallet',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/tax-equivalent-yield',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Tax-Equivalent Yield Calculator – Municipal Bond Yield Comparison',
    description: 'Free tax-equivalent yield calculator to compare municipal bond yields with taxable bond yields. Calculate the before-tax yield needed to match a tax-free municipal bond return.',
  },
};

export default meta;
